export enum PMSIntegrationType {
    None = 0,
    Colibri = 1,
    Protel = 2
  }